//# sourceMappingURL=my-month-labels.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/mydatepicker/dist/interfaces/my-month-labels.interface.js
// module id = 967
// module chunks = 33